Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    cardBackgroundColorDefault: tokens.themeSurfaceDefault,
    cardBackgroundColorPressed: tokens.themeActionNeutralSelected,
    cardBackgroundColorDisabled: tokens.themeSurfaceDisabled,
    cardBorderWidth: 1,
    cardBorderRadius: 4,
    cardBorderColor: tokens.themeBorderSurface,
    cardSpacingInset: 32,
    cardSpacingVertical: 16,
    cardDropShadowDefaultOffsetX: 0,
    cardDropShadowDefaultOffsetY: 2,
    cardDropShadowDefaultBlur: 4,
    cardDropShadowDefaultSpread: 0,
    cardDropShadowDefaultColor: "#02080E",
    cardDropShadowDefaultOpacity: 16,
    cardDropShadowHoverOffsetX: 0,
    cardDropShadowHoverOffsetY: 4,
    cardDropShadowHoverBlur: 8,
    cardDropShadowHoverSpread: 0,
    cardDropShadowHoverColor: "#02080E",
    cardDropShadowHoverOpacity: 16,
    cardDropShadowPressedOffsetX: 0,
    cardDropShadowPressedOffsetY: 3,
    cardDropShadowPressedBlur: 6,
    cardDropShadowPressedSpread: 0,
    cardDropShadowPressedColor: "#02080E",
    cardDropShadowPressedOpacity: 16,
    cardOffsetVerticalDefault: 0,
    cardOffsetVerticalHover: -4,
    cardOffsetVerticalPressed: -2,
    cardTextDefaultFontSize: 16,
    cardTextDefaultFontWeight: 400,
    cardTextDefaultLineHeight: "24px",
    cardTextDefaultForegroundColor: tokens.themeInkDefault
  }
};